// posthog.js — MODULE 1: PostHog stub + deferred init
//
// The PostHog stub (window.posthog with method queueing) is installed
// unconditionally so that api.js / hubspot.js can call posthog.identify,
// posthog.capture, etc. before consent state is known — those calls
// queue and replay once init() runs.
//
// posthog.init() itself is deferred until consent state is read by
// consent.js, which calls loadPostHog('accepted') or loadPostHog('rejected').
// This avoids the opt-out-default + cookieless-mode interaction that
// resets the cross-subdomain .probabl.ai identity cookie.

import { cfg, LOG, dbg } from './config.js';

try {
  if (!cfg.no_track) {
    // Standard posthog-js loader snippet — installs window.posthog as a
    // method-queueing stub. Does NOT call init().
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    dbg('PostHog stub installed');
  }
} catch (e) {
  console.error(LOG, 'PostHog stub error', e);
}

// Called from consent.js once the user's consent state is known.
// 'accepted' → vanilla init: autocapture pageview, persistent identity,
//   cross-subdomain cookie shared across *.probabl.ai.
// 'rejected' → cookieless init: opt-out by default, cookieless_mode
//   captures anonymous events without persistent identifiers. The
//   explicit opt_out_capturing() call overrides any stored opt-in
//   from a prior accept (change-of-mind safety).
export function loadPostHog(state) {
  if (cfg.no_track) { return; }
  if (!window.posthog) { return; }
  try {
    if (state === 'accepted') {
      window.posthog.init(cfg.posthog_key, {
        api_host:        cfg.posthog_host,
        person_profiles: cfg.person_profiles
      });
      dbg('PostHog init (accepted)');
    } else if (state === 'rejected') {
      window.posthog.init(cfg.posthog_key, {
        api_host:                     cfg.posthog_host,
        person_profiles:              cfg.person_profiles,
        opt_out_capturing_by_default: true,
        cookieless_mode:              'on_reject'
      });
      window.posthog.opt_out_capturing();
      dbg('PostHog init (rejected)');
    }
  } catch (e) {
    console.error(LOG, 'PostHog init error', e);
  }
}
